import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import MultiSelect from "../../multi_select/multi_select";
import SearchRefineMultiSelectCheckboxOption from "./search_refine_multi_select_checkbox_option/search_refine_multi_select_checkbox_option";

const SearchRefineMultiSelect = ({
  customComponents,
  items,
  placeholder,
  refine,
  styles,
}) => {
  const selected = useMemo(() => {
    return items.filter((item) => {
      return item.isRefined;
    });
  }, [items]);

  const refineBasedOnSelectValue = useCallback(
    (selectValue) => {
      const filters = selectValue.map((multiSelectValue) => {
        return multiSelectValue.label;
      });
      return refine(filters);
    },
    [refine]
  );

  const components = useMemo(() => {
    return {
      Option: SearchRefineMultiSelectCheckboxOption,
      ...customComponents,
    };
  }, [customComponents]);

  return (
    <MultiSelect
      customComponents={components}
      isClearable={false}
      isMulti
      value={selected}
      onChange={refineBasedOnSelectValue}
      operator="or"
      options={items}
      placeholder={placeholder}
      styles={styles}
    />
  );
};

SearchRefineMultiSelect.propTypes = {
  customComponents: PropTypes.shape({}),
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  placeholder: PropTypes.string,
  refine: PropTypes.func.isRequired,
  selectProps: PropTypes.shape({}),
  styles: PropTypes.shape({}),
};

SearchRefineMultiSelect.defaultProps = {
  customComponents: null,

  placeholder: "Select",
  selectProps: null,
  styles: null,
};

export default SearchRefineMultiSelect;
